import { render, staticRenderFns } from "./form.vue?vue&type=template&id=c64cc23e&scoped=true"
import script from "./form.vue?vue&type=script&lang=js"
export * from "./form.vue?vue&type=script&lang=js"
import style0 from "./form.vue?vue&type=style&index=0&id=c64cc23e&prod&lang=less&scoped=true"
import style1 from "./form.vue?vue&type=style&index=1&id=c64cc23e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c64cc23e",
  null
  
)

export default component.exports